import { createFileRoute } from "@tanstack/react-router";
import { LocationPage, locationHead } from "../components/LocationPage";
import { locatieContent } from "../lib/locatie-content";

export const Route = createFileRoute("/timmerman-dordrecht")({
  head: () => locationHead(locatieContent.dordrecht),
  component: () => <LocationPage slug="dordrecht" />,
});
